import { createFileRoute } from '@tanstack/react-router';
import { DeveloperMcpSettingsPage } from '../components/settings/developer-mcp-settings.js';

export const Route = createFileRoute('/settings/developer/mcp')({
  component: DeveloperMcpSettingsPage,
});
